export default __webpack_public_path__ + "static/spinhead-c989b7a9525f0c7555a27fb96ccc015b.mp4";